import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import ReactMarkdown from 'react-markdown';
import { NavLink } from "react-router-dom";
import ProducteurPresent from './producteurPresent.js';
import BiassesProducteurs from './biassesProducteurs';
import { updateBiasse } from '../actions/actions-types';

const Biasses = (props) => {
    const { userCJ } = useSelector(state => state);
    const [biasses, setBiasses] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const headers = new Headers();
        headers.append('cle', cle_COURTJUS);

        fetch(`${URL_COURTJUS_BACK}/biasses`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                // Étape de sécurité : On s'assure que bParticipants est TOUJOURS un tableau dans notre state local
                const formattedBiasses = res.map(biasse => {
                    let participants = biasse.bParticipants;
                    if (typeof participants === 'string') {
                        // Transforme "1,2,3" en [1, 2, 3] ou gère une chaîne vide
                        participants = participants ? participants.split(',').map(id => id.trim()) : [];
                    }
                    return { ...biasse, bParticipants: participants || [] };
                });
                setBiasses(formattedBiasses);
            })
            .catch(err => console.error("Erreur lors du chargement des biasses:", err));
    }, []);

    const handleFicheChange = (updatedFiche) => {
        // 1. On garde bParticipants sous forme de TABLEAU pour le state local de React
        // On s'assure que updatedFiche.bParticipants est bien un tableau propre
        const localFiche = {
            ...updatedFiche,
            bParticipants: Array.isArray(updatedFiche.bParticipants)
                ? [...updatedFiche.bParticipants]
                : (updatedFiche.bParticipants ? updatedFiche.bParticipants.split(',') : [])
        };

        // 2. On met à jour le state local du parent avec l'objet contenant le TABLEAU
        const updatedBiasses = biasses.map(b =>
            String(b.bNum) === String(localFiche.bNum) ? localFiche : b
        );
        setBiasses(updatedBiasses);

        // 3. UNIQUEMENT POUR REDUX / BDD : On crée une copie convertie en CHAÎNE "1,2,3"
        const fichePourBackend = {
            ...localFiche,
            bParticipants: localFiche.bParticipants.join(',')
        };

        // 4. On envoie à Redux la version textuelle que ton API attend
        dispatch(updateBiasse({ biasseFiche: fichePourBackend }));
    };

    return (
        <main className="container">
            <div className="main-down"></div>

            <section className='main-title'>
                <p>
                    Marchés / Biasses
                    {userCJ.uAdmin > 0 && (
                        <NavLink to={`/biasses/0`} aria-label="Ajouter un marché / une biasse" title="Ajouter un marché / une biasse" style={{ marginLeft: 50 }} className="btn btn-primary">
                            <img src="/img/storefront_add.png" className={'btn-articles'} alt="Ajouter une biasse" /> ajouter
                        </NavLink>
                    )}
                </p>
            </section>

            {biasses.map((q, i) => (
                <section
                    className={`section-prods ${q.bActif ? 'section-prods-actif' : ''}`}
                    // ICI : On change la key pour forcer React à rafraîchir cette section précise
                    key={`${q.bNum}-${q.bParticipants?.toString()}`}
                >
                    <article className="section-prods-fiche">
                        <h2>
                            {userCJ.uAdmin > 0 && (
                                <NavLink to={`/biasses/${q.bNum}`} aria-label="Modifier la fiche" title="modifier la fiche">
                                    <img src="/img/edit_R.png" className="btn-articles" alt="Modifier la Biasse" />
                                </NavLink>
                            )}
                            <span>{q.bLibelle}.</span>

                        </h2>
                        <p className="p-impact">
                            {(q.bActif && userCJ.uProducteur) && (
                                <ProducteurPresent
                                    userId={userCJ.uNum}
                                    biasseFiche={q}
                                    onFicheChange={handleFicheChange}
                                />
                            ) || ''}
                            Le {q.bDate?.substring(8, 10)}/{q.bDate?.substring(5, 7)}/{q.bDate?.substring(0, 4)}
                        </p>
                        <h3>Commande entre
                            le <span className='p-impact'>{q.bDateCdeIni?.substring(8, 10)}/{q.bDateCdeIni?.substring(5, 7)}/{q.bDateCdeIni?.substring(0, 4)} </span>
                            et le <span className='p-impact'>{q.bDateCdeEnd?.substring(8, 10)}/{q.bDateCdeEnd?.substring(5, 7)}/{q.bDateCdeEnd?.substring(0, 4)}</span>
                        </h3>
                    </article>
                    <article className="section-prods-infos">
                        <ReactMarkdown>{q.bComment ? q.bComment.replace(/\n/g, '  \n') : ''}</ReactMarkdown>
                    </article>
                    <article className="section-prods-infos">
                        <BiassesProducteurs bParticipants={q.bParticipants} userId={userCJ.uNum} />
                    </article>
                </section>
            ))}
            <div className="main-down"></div>
        </main>
    );
};

export default Biasses;